export function camelToSnakeCase (str: string) {
  const upperChars = str.match(/([A-Z])/g);

  if (!upperChars) {
    return str;
  }

  let l = upperChars.length;

  while (l-- > 0) {
    str = str.replace(new RegExp(upperChars[l]), '_' + upperChars[l].toLowerCase());
  }

  if (str.slice(0, 1) === '_') {
    str = str.slice(1);
  }

  return str;
}

export function objectKeysToSnakeCase (obj: Object) {
  const res = Object.create(null);
  const keys = Object.keys(obj);
  let l = keys.length;

  while (l-- > 0) {
    const snCaseKey = camelToSnakeCase(keys[l]);
    res[snCaseKey] = obj[keys[l]];
  }

  return res;
}

export function snakeToCamelCase(str: string): string {
  let strBuffer = str.split('_');

  if (strBuffer.length === 1) {
     return strBuffer[0];
  }

  let camelString = strBuffer[0];

  for (let i = 1; i < strBuffer.length; i++) {
    camelString += (strBuffer[i][0].toUpperCase() + strBuffer[i].slice(1));
  }

  return camelString;
}

export function objectKeysToCamelCase(obj: Object) {
  const res = Object.create({});
  const keys = Object.keys(obj);
  let l = keys.length;

  while (l--) {
    const cmlCaseKey = snakeToCamelCase(keys[l]);
    res[cmlCaseKey] = obj[keys[l]];
  }

  return res;
}

export function isDef (v: any): boolean {
  return v !== undefined && v !== null
}

export function isUndef (v: any): boolean {
  return v === undefined || v === null
}

export function removeById (arr: Array<any>, id: any): Array<any> | void {
  if (arr.length) {
    const index = arr.findIndex(item => item.id === id);
    if (index > -1) {
      return arr.splice(index, 1)
    }
  }
}


// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/(IGH Projects)/jobs/EVFS PROD_FRONTEND granima.de/workspace/frontend/src/app/utils/index.ts